import { render, staticRenderFns } from "./JustificationPicker.vue?vue&type=template&id=2b75e407"
import script from "./JustificationPicker.vue?vue&type=script&lang=js"
export * from "./JustificationPicker.vue?vue&type=script&lang=js"
import style0 from "./JustificationPicker.vue?vue&type=style&index=0&id=2b75e407&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports